import { COLOR } from '../color';

export const RADAR_TARGET_THEME = {
    HISTORY_DOT_INSIDE_RANGE: COLOR.WHITE,
    HISTORY_DOT_OUTSIDE_RANGE: COLOR.GRAY_LIGHT,
    HISTORY_DOT_RADIUS_KM: 0.2,
    HISTORY_LENGTH: 10,
    PROJECTED_TRACK_LINES: COLOR.WHITE,
    PROJECTION_ARRIVAL: COLOR.RED_06,
    PROJECTION_ARRIVAL_ALL: COLOR.RED_02,
    PROJECTION_DEPARTURE: COLOR.BLUE_06,
    PROJECTION_DEPARTURE_ALL: COLOR.BLUE_02,
    PROJECTION_ESTABLISHED_ON_APPROACH: COLOR.RED,
    RADAR_TARGET: COLOR.GRAY_LIGHT,
    RADIUS_KM: 0.5,
    RADIUS_SELECTED_KM: 0.75,
    RING_CONFLICT: COLOR.WHITE_02,
    RING_VIOLATION: COLOR.RED,
    HALO: COLOR.GREEN_LIGHT,
    TRAILING_SEPARATION_INDICATOR_ENABLED: true,
    TRAILING_SEPARATION_INDICATOR: COLOR.RED_08
};
